(function () {
  if (window.__phEndlessScroll) return;
  window.__phEndlessScroll = true;

  var loading = false;

  function nextLink() {
    return document.querySelector('.pagination .next a');
  }

  function gridBefore(pagination) {
    var node = pagination;
    while (node && node !== document.body) {
      var prev = node.previousElementSibling;
      while (prev) {
        if (prev.classList && prev.classList.contains('grid')) return prev;
        if (prev.querySelector) {
          var inner = prev.querySelector('.grid--uniform, .grid');
          if (inner) return inner;
        }
        prev = prev.previousElementSibling;
      }
      node = node.parentElement;
    }
    return null;
  }

  function conceal(el) {
    el.style.height = '1px';
    el.style.overflow = 'hidden';
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
    el.style.margin = '0';
    el.setAttribute('aria-hidden', 'true');
  }

  function show(el) {
    el.style.height = '';
    el.style.overflow = '';
    el.style.opacity = '';
    el.style.pointerEvents = '';
    el.style.margin = '';
    el.removeAttribute('aria-hidden');
  }

  function reveal(node) {
    node.classList.add('aos-init', 'aos-animate');
  }

  function loadNext() {
    var link = nextLink();
    if (!link || loading) return;
    var pagination = link.closest('.pagination');
    var grid = gridBefore(pagination);
    if (!grid) return;

    loading = true;
    fetch(link.href, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('page');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPagination = doc.querySelector('.pagination');
        var newGrid = newPagination ? gridBefore(newPagination) : null;
        if (!newGrid) throw new Error('grid');

        var seen = {};
        var current = grid.querySelectorAll('[data-product-id]');
        for (var i = 0; i < current.length; i++) {
          seen[current[i].getAttribute('data-product-id')] = true;
        }

        var items = newGrid.children;
        for (var j = 0; j < items.length; j++) {
          var item = items[j];
          if (!item.classList || !item.classList.contains('grid__item')) continue;
          var id = item.getAttribute('data-product-id');
          if (id && seen[id]) continue;
          reveal(item);
          grid.appendChild(document.importNode(item, true));
        }

        if (newPagination && newPagination.querySelector('.next a')) {
          var imported = document.importNode(newPagination, true);
          pagination.replaceWith(imported);
          conceal(imported);
        } else {
          pagination.remove();
        }

        if (window.AOS && typeof window.AOS.refresh === 'function') window.AOS.refresh();
        if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
      })
      .catch(function () {
        show(pagination);
      })
      .then(function () {
        loading = false;
        maybeLoad();
      });
  }

  function maybeLoad() {
    var link = nextLink();
    if (!link || loading) return;
    var pagination = link.closest('.pagination');
    conceal(pagination);
    var rect = pagination.getBoundingClientRect();
    if (rect.top < window.innerHeight + 900) loadNext();
  }

  window.addEventListener('scroll', maybeLoad, { passive: true });
  window.addEventListener('load', maybeLoad);
  if (document.readyState !== 'loading') maybeLoad();
})();
